import { Content as RadixTabContent } from "@radix-ui/react-tabs";

import { styled } from "../../theme";

export const TabContent = styled(RadixTabContent, {});
